import { IBase, ICachedAddress, ICoordinate, IFavoriteResponse, IReservation, ISearchedType, ISearchStop, IServiceInfo, IStop, IStopAvailabilityTimes } from '../../../models'

export enum BusStopsStepTypeKeys {
  RESET_NEW_RESERVATION_FIELDS = 'RESET_NEW_RESERVATION_FIELDS',
  SET_NEW_RESERVATION_FIELDS = 'SET_NEW_RESERVATION_FIELDS',
  SET_FAVORITE_NEW_RESERVATION_FIELDS = 'SET_FAVORITE_NEW_RESERVATION_FIELDS',
  FETCH_SERVICES = 'FETCH_SERVICES',
  FETCHING_SERVICES = 'FETCHING_SERVICES',
  FETCH_SERVICES_SUCCESSFUL = 'FETCH_SERVICES_SUCCESSFUL',
  SET_IS_SEARCHING = 'SET_IS_SEARCHING',
  SEARCH_STOPS = 'SEARCH_STOPS',
  SET_SEARCH_STOPS = 'SET_SEARCH_STOPS',
  SEARCH_STOP_COORDINATES = 'SEARCH_STOP_COORDINATES',
  SET_SEARCHED_RESULT = 'SET_SEARCHED_RESULT',
  SET_SELECT_MARKER_FLAG = 'SET_SELECT_MARKER_FLAG',
  SET_BUS_STOP = 'SET_BUS_STOP',
  FETCH_DESTINATION_BUS_STOPS = 'FETCH_DESTINATION_BUS_STOPS',
  FETCHING_DESTINATION_BUS_STOPS = 'FETCHING_DESTINATION_BUS_STOPS',
  FETCH_DESTINATION_BUS_STOPS_SUCCESSFUL = 'FETCH_DESTINATION_BUS_STOPS_SUCCESSFUL',
  SET_MAP_CHANGED_CENTER = 'SET_MAP_CHANGED_CENTER',
  RESET_MAP_CHANGED_CENTER = 'RESET_MAP_CHANGED_CENTER',
  SET_SERVICE_SELECTED = 'SET_SERVICE_SELECTED',
  SET_USER_LOCATION = 'SET_USER_LOCATION',
  SET_ROUND_TRIP = 'SET_ROUND_TRIP',
  SET_SHOW_TRIP_TYPE_OPTIONS = 'SET_SHOW_TRIP_TYPE_OPTIONS',
  SHOW_SINGLE_STOP_MODAL = 'SHOW_SINGLE_STOP_MODAL',
  SET_SINGLE_BUS_STOP_DIRECTION = 'SET_SINGLE_BUS_STOP_DIRECTION',
  RESET_SINGLE_BUS_STOP = 'RESET_SINGLE_BUS_STOP',
  SET_IS_SEARCHING_COORDS_IN_MAP = 'SET_IS_SEARCHING_COORDS_IN_MAP',
  SET_IS_MAP_CENTER_WITHIN_OUTLINES = 'SET_IS_MAP_CENTER_WITHIN_OUTLINES',
  SET_PREVIEW_BUS_STOP = 'SET_PREVIEW_BUS_STOP',
  SET_PREVIEW_ORIGIN_STOP = 'SET_PREVIEW_ORIGIN_STOP',
  SET_PREVIEW_DESTINATION_STOP = 'SET_PREVIEW_DESTINATION_STOP',
  LOAD_CACHED_ADDRESSES = 'LOAD_CACHED_ADDRESSES',
  SET_CACHED_ADDRESSES = 'SET_CACHED_ADDRESSES',
  ADD_CACHED_ADDRESS = 'ADD_CACHED_ADDRESS',
  FETCH_STOP_AVAILABILITY_TIMES = 'FETCH_STOP_AVAILABILITY_TIMES',
  SET_IS_FETCHING_STOP_AVAILABILITY_TIMES = 'SET_IS_FETCHING_STOP_AVAILABILITY_TIMES',
  SET_STOP_AVAILABILITY_TIMES = 'SET_STOP_AVAILABILITY_TIMES',
  RESET_STOP_AVAILABILITY_TIMES = 'RESET_STOP_AVAILABILITY_TIMES',
}

export interface IFetchStopAvailabilityTimesAction {
  type: typeof BusStopsStepTypeKeys.FETCH_STOP_AVAILABILITY_TIMES
  payload: { stopId: number, date: Date, serviceInfos: IServiceInfo[] }
  [extraProps: string]: unknown
}

export interface ISetIsFetchingStopAvailabilityTimesAction {
  type: typeof BusStopsStepTypeKeys.SET_IS_FETCHING_STOP_AVAILABILITY_TIMES
  payload: boolean
  [extraProps: string]: unknown
}

export interface ISetStopAvailabilityTimesAction {
  type: typeof BusStopsStepTypeKeys.SET_STOP_AVAILABILITY_TIMES
  payload: IStopAvailabilityTimes[]
  [extraProps: string]: unknown
}

export interface IResetStopAvailabilityTimesAction {
  type: typeof BusStopsStepTypeKeys.RESET_STOP_AVAILABILITY_TIMES
  [extraProps: string]: unknown
}

export interface ILoadCachedAddressesAction {
  type: typeof BusStopsStepTypeKeys.LOAD_CACHED_ADDRESSES
  [extraProps: string]: unknown
}

export interface ISetCachedAddressesAction {
  type: typeof BusStopsStepTypeKeys.SET_CACHED_ADDRESSES
  payload: ICachedAddress[]
  [extraProps: string]: unknown
}

export interface IAddCachedAddressAction {
  type: typeof BusStopsStepTypeKeys.ADD_CACHED_ADDRESS
  payload: ICachedAddress
  [extraProps: string]: unknown
}

export interface ISetIsSearchingCoordsInMapAction {
  type: typeof BusStopsStepTypeKeys.SET_IS_SEARCHING_COORDS_IN_MAP
  payload: boolean
  [extraProps: string]: unknown
}

export interface ISetIsMapCenterWithinOutlinesAction {
  type: typeof BusStopsStepTypeKeys.SET_IS_MAP_CENTER_WITHIN_OUTLINES
  payload: boolean
  [extraProps: string]: unknown
}

export interface ISetPreviewBusStopAction {
  type: typeof BusStopsStepTypeKeys.SET_PREVIEW_BUS_STOP
  payload: { coordinates: ICoordinate, isOrigin: boolean }
  [extraProps: string]: unknown
}

export interface ISetPreviewOriginStopAction {
  type: typeof BusStopsStepTypeKeys.SET_PREVIEW_ORIGIN_STOP
  payload?: IStop
  [extraProps: string]: unknown
}

export interface ISetPreviewDestinationStopAction {
  type: typeof BusStopsStepTypeKeys.SET_PREVIEW_DESTINATION_STOP
  payload?: IStop
  [extraProps: string]: unknown
}

export interface IResetNewReservationFieldsAction {
  type: typeof BusStopsStepTypeKeys.RESET_NEW_RESERVATION_FIELDS
  [extraProps: string]: unknown
}

export interface ISetNewReservationFieldsAction {
  type: typeof BusStopsStepTypeKeys.SET_NEW_RESERVATION_FIELDS
  payload: IReservation
  [extraProps: string]: unknown
}

export interface ISetFavoriteNewReservationFieldsAction {
  type: typeof BusStopsStepTypeKeys.SET_FAVORITE_NEW_RESERVATION_FIELDS
  payload: IFavoriteResponse
  [extraProps: string]: unknown
}

export interface IFetchServicesAction {
  type: typeof BusStopsStepTypeKeys.FETCH_SERVICES
  [extraProps: string]: unknown
}

export interface ISetIsFetchingServicesAction {
  type: typeof BusStopsStepTypeKeys.FETCHING_SERVICES
  [extraProps: string]: unknown
}

export interface IFetchServicesSuccessfulAction {
  type: typeof BusStopsStepTypeKeys.FETCH_SERVICES_SUCCESSFUL
  payload: IServiceInfo[]
  [extraProps: string]: unknown
}

export interface ISetIsSeachingAction {
  type: typeof BusStopsStepTypeKeys.SET_IS_SEARCHING
  payload: boolean
  [extraProps: string]: unknown
}

export interface ISearchStopsAction {
  type: typeof BusStopsStepTypeKeys.SEARCH_STOPS
  payload: string
  [extraProps: string]: unknown
}

export interface ISetSearchStopsAction {
  type: typeof BusStopsStepTypeKeys.SET_SEARCH_STOPS
  payload: IBase[]
  [extraProps: string]: unknown
}

export interface ISearchStopCoordinatesAction {
  type: typeof BusStopsStepTypeKeys.SEARCH_STOP_COORDINATES
  payload: ISearchStop
  [extraProps: string]: unknown
}

export interface ISetSearchedStopResultAction {
  type: typeof BusStopsStepTypeKeys.SET_SEARCHED_RESULT
  payload: { name: string }
  [extraProps: string]: unknown
}

export interface ISetSelectMarkerFlagAction {
  type: typeof BusStopsStepTypeKeys.SET_SELECT_MARKER_FLAG
  payload: boolean
  [extraProps: string]: unknown
}

export interface ISetBusStopAction {
  type: typeof BusStopsStepTypeKeys.SET_BUS_STOP
  payload: { stop: IStop }
  [extraProps: string]: unknown
}

export interface IFetchDestinationBusStopsAction {
  type: typeof BusStopsStepTypeKeys.FETCH_DESTINATION_BUS_STOPS
  payload: { idTown: number; stop: IStop }
  [extraProps: string]: unknown
}

export interface ISetIsFetchingDestinationBusStopsAction {
  type: typeof BusStopsStepTypeKeys.FETCHING_DESTINATION_BUS_STOPS
  [extraProps: string]: unknown
}

export interface IFetchDestinationBusStopsSuccesfulAction {
  type: typeof BusStopsStepTypeKeys.FETCH_DESTINATION_BUS_STOPS_SUCCESSFUL
  payload: IStop[]
  [extraProps: string]: unknown
}

export interface ISetMapChangedCenterAction {
  type: typeof BusStopsStepTypeKeys.SET_MAP_CHANGED_CENTER
  payload: ICoordinate
  [extraProps: string]: unknown
}

export interface IResetMapChangedCenterAction {
  type: typeof BusStopsStepTypeKeys.RESET_MAP_CHANGED_CENTER
  [extraProps: string]: unknown
}

export interface ISetServiceSelectedAction {
  type: typeof BusStopsStepTypeKeys.SET_SERVICE_SELECTED,
  payload: any
  [extraProps: string]: unknown
}

export interface ISetUserLocationAction {
  type: typeof BusStopsStepTypeKeys.SET_USER_LOCATION,
  payload: ICoordinate | undefined
  [extraProps: string]: unknown
}

export interface ISetRoundTripAction {
  type: typeof BusStopsStepTypeKeys.SET_ROUND_TRIP,
  payload: boolean
  [extraProps: string]: unknown
}

export interface ISetShowTripTypeOptionsActions {
  type: typeof BusStopsStepTypeKeys.SET_SHOW_TRIP_TYPE_OPTIONS,
  payload: boolean
}

export interface ISetShowSingleStopModalAction {
  type: typeof BusStopsStepTypeKeys.SHOW_SINGLE_STOP_MODAL,
  payload: {isSingleStopModalOpen: boolean, stop?: IStop}
  [extraProps: string]: unknown
}

export interface ISetSingleBusStopAction {
  type: typeof BusStopsStepTypeKeys.SET_SINGLE_BUS_STOP_DIRECTION
  payload: {isOrigin: boolean, stop?: IStop}
  [extraProps: string]: unknown
}

export interface IResetSingleBusStopAction {
  type: typeof BusStopsStepTypeKeys.RESET_SINGLE_BUS_STOP
  [extraProps: string]: unknown
}

export type BusStopsStepActionTypes =
 | IResetNewReservationFieldsAction
 | ISetNewReservationFieldsAction
 | ISetFavoriteNewReservationFieldsAction
 | IFetchServicesAction
 | ISetIsFetchingServicesAction
 | IFetchServicesSuccessfulAction
 | ISetIsSeachingAction
 | ISearchStopsAction
 | ISetSearchStopsAction
 | ISearchStopCoordinatesAction
 | ISetSearchedStopResultAction
 | ISetSelectMarkerFlagAction
 | ISetBusStopAction
 | IFetchDestinationBusStopsAction
 | ISetIsFetchingDestinationBusStopsAction
 | IFetchDestinationBusStopsSuccesfulAction
 | ISetMapChangedCenterAction
 | IResetMapChangedCenterAction
 | ISetServiceSelectedAction
 | ISetUserLocationAction
 | ISetRoundTripAction
 | ISetShowTripTypeOptionsActions
 | ISetShowSingleStopModalAction
 | ISetSingleBusStopAction
 | IResetSingleBusStopAction
 | ISetIsSearchingCoordsInMapAction
 | ISetIsMapCenterWithinOutlinesAction
 | ISetPreviewBusStopAction
 | ISetPreviewOriginStopAction
 | ISetPreviewDestinationStopAction
 | ILoadCachedAddressesAction
 | ISetCachedAddressesAction
 | IAddCachedAddressAction
 | IFetchStopAvailabilityTimesAction
 | ISetIsFetchingStopAvailabilityTimesAction
 | ISetStopAvailabilityTimesAction
 | IResetStopAvailabilityTimesAction
